export const iconFontAwesomeEditingArrowsRotate = (
	<i className="fa-solid fa-arrows-rotate"></i>
);
